import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import React from 'react';

class FooterDeleteButton extends React.Component {
  static defaultProps = {enabled: true};

  static propTypes = {
    enabled: PropTypes.bool,
    onDelete: PropTypes.func.isRequired,
    label: PropTypes.string,
  };
  state = {confirming: false};

  onCancel = () => {
    this.setState({confirming: false});
  };

  onDelete = () => {
    this.setState({confirming: true});
  };

  deleteWrapper = (e) => {
    this.setState({confirming: false});
    this.props.onDelete(e);
  };

  render() {
    if (this.state.confirming) {
      return (
        <span className='footer-item footer-edit-options'>
          <i className='footer-item-icon bl bl-delete fa-2x'/>
          <FormattedMessage id='general.delete' />?
          &nbsp;
          <button className='btn btn-default' onClick={this.onCancel}><FormattedMessage id='general.cancel' /></button>
          <button className='btn btn-primary' onClick={this.deleteWrapper}>{this.props.label || 'Confirm'}</button>
        </span>
      );
    }

    let button;

    if (this.props.enabled) {
      button = <span className='footer-item' onClick={this.onDelete}>
        <i className='footer-item-icon bl bl-delete fa-2x'/>
        <FormattedMessage id='general.delete' />
      </span>;
    } else {
      button = <span className='footer-item' style={{opacity: 0.65, cursor: 'not-allowed'}}>
        <i className='footer-item-icon bl bl-delete fa-2x' />
        <FormattedMessage id='general.delete' />
      </span>;
    }

    return button;
  }
}

export default FooterDeleteButton;
